//@flow
import { CommonActions } from '@react-navigation/native';
import Navigation from '../../lib/navigation';

export type Action =
  | {|
      type: 'GO_TO_SIM_ACTIVATION',
    |}
  | {|
      type: 'GO_TO_SIGN_UP',
    |}
  | {|
      type: 'GO_TO_INVITE_A_FRIEND',
    |}
  | {|
      type: 'REDIRECT_AFTER_LOGIN',
      payload: { redirectPath: string },
    |};

export const resetToDashboard = () =>
  Navigation.dispatch(CommonActions.reset({ index: 0, routes: [{ name: 'connected' }] }));

export const resetToWelcomeScreen = () =>
  Navigation.dispatch(CommonActions.reset({ index: 0, routes: [{ name: 'welcome' }] }));

export const goToSignUp = (): Action => ({
  type: 'GO_TO_SIGN_UP',
});

export const goToSimActivation = (): Action => ({
  type: 'GO_TO_SIM_ACTIVATION',
});

export const goToInviteAFriend = (): Action => ({
  type: 'GO_TO_INVITE_A_FRIEND',
});

export const redirectAfterLogin = (redirectPath: string): Action => ({
  type: 'REDIRECT_AFTER_LOGIN',
  payload: { redirectPath },
});
